import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { useTranslation } from "react-i18next";
import AppInformation from './AppInformation';
import GeneralSettings from './GeneralSettings';
import LanguageSetting from './LanguageSetting';
import SMTPSettings from './SMTPSettings';
import { PageHeader } from '../common/tableTheme';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function Settings() {
  const [value, setValue] = React.useState(0);
  const { t } = useTranslation();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%', p: 0.5 }}>
      <PageHeader 
        title="Configurações do Sistema" 
        subtitle="Parâmetros operacionais da frota, dados do aplicativo, idiomas e comunicação."
      />
      <Box sx={{ 
        bgcolor: '#f1f5f9', 
        p: 0.5, 
        borderRadius: '12px', 
        display: 'inline-flex',
        border: '1px solid #e2e8f0',
        mb: 2.5
      }}>
        <Tabs 
          value={value} 
          onChange={handleChange} 
          TabIndicatorProps={{ style: { display: 'none' } }}
          sx={{
            minHeight: '36px',
            '& .MuiTab-root': {
              minHeight: '36px',
              py: 0.75,
              px: 2,
              borderRadius: '8px',
              fontSize: '0.8125rem',
              fontWeight: 600,
              textTransform: 'none',
              color: '#64748b',
              transition: 'all 0.15s ease',
              '&.Mui-selected': {
                color: '#ffffff',
                bgcolor: '#0f172a',
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
              }
            }
          }}
        >
          <Tab label={t('app_info') || 'Informações'} {...a11yProps(0)} />
          <Tab label={t('general_settings') || 'Gerais'} {...a11yProps(1)} />
          <Tab label={t('language') || 'Idioma'} {...a11yProps(2)} />
          <Tab label={t('smtp') || 'E-mail / SMTP'} {...a11yProps(3)} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <AppInformation/>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <GeneralSettings/>
      </TabPanel>
      <TabPanel value={value} index={2}>
        <LanguageSetting/>
      </TabPanel>
      <TabPanel value={value} index={3}>
        <SMTPSettings/>
      </TabPanel>
    </Box>
  );
}